import { render } from "./SuccessStoryDetailsPage.vue?vue&type=template&id=0d90a5aa&scoped=true&ts=true"
import script from "./SuccessStoryDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SuccessStoryDetailsPage.vue?vue&type=script&lang=ts"

import "./SuccessStoryDetailsPage.vue?vue&type=style&index=0&id=0d90a5aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d90a5aa"]])

export default __exports__